import { SVGProps } from "react";
import { JSX } from "react/jsx-runtime";

const UncheckedBoxIcon = (props: JSX.IntrinsicAttributes & SVGProps<SVGSVGElement>) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.10967 2.33203C3.42301 2.33203 2.33301 3.48736 2.33301 5.27603V10.7214C2.33301 12.51 3.42301 13.6654 5.10967 13.6654H10.8883C12.5757 13.6654 13.6663 12.51 13.6663 10.7214V5.27603C13.6663 3.48736 12.5757 2.33203 10.889 2.33203H5.10967ZM10.8883 14.6654H5.10967C2.85034 14.6654 1.33301 13.08 1.33301 10.7214V5.27603C1.33301 2.91736 2.85034 1.33203 5.10967 1.33203H10.889C13.1483 1.33203 14.6663 2.91736 14.6663 5.27603V10.7214C14.6663 13.08 13.1483 14.6654 10.8883 14.6654V14.6654Z"
      fill="#011533"
    />
  </svg>
);

export default UncheckedBoxIcon;
